import React from "react";
import {GiTwoCoins} from "react-icons/gi";
import {formatCredits, formatCreditsCompact, formatCreditsFixed} from "../../utils/FormatUtils";

type Props = {
    value?: number;
    fixedDecimals?: number;
    compact?: boolean;
    showIcon?: boolean;
    className?: string;
};

function CreditsValue(props: Props) {
    const text = props.fixedDecimals !== undefined
        ? formatCreditsFixed(props.value, props.fixedDecimals)
        : (props.compact ? formatCreditsCompact(props.value) : formatCredits(props.value));

    return (
        <span
            className={props.className}
            style={{display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap"}}
        >
            {props.showIcon !== false && <GiTwoCoins aria-hidden={true} style={{color: "#c27c00", flexShrink: 0}}/>}
            <span>{text}</span>
        </span>
    );
}

export default CreditsValue;
